import $ from "jquery";
import Inputmask from "inputmask";

function submitFormWithRecaptcha(form) {
    const key = window.captchaKey || "";
    if (!key) {
        form[0].submit();
        return;
    }

    grecaptcha.ready(function () {
        grecaptcha.execute(key, { action: "submit" }).then(function (token) {
            form.find('input[name="g-recaptcha-response"]').val(token);
            form[0].submit();
        });
    });
}

const forms = () => {
    //маска телефона
    Inputmask({ mask: "+7 (999) 999 99 99" }).mask($(".js-phone"));

    if ($(".js-select").length) {
        $(".js-select").each(function () {
            $(this).select2({
                width: "100%",
                minimumResultsForSearch: Infinity,
                placeholder: $(this).attr("placeholder")
                    ? $(this).attr("placeholder")
                    : "Выбрать",
            });
        });
    }

    $(".form.callback__form .form__submit").on("click", function (e) {
        e.preventDefault();
        const form = $(this).closest(".form");

        if (!checkRequiredFields(form)) {
            return false;
        }

        submitFormWithRecaptcha(form);
    });

    $(".form.brand-feedback__form .form__submit").on("click", function (e) {
        e.preventDefault();
        const form = $(this).closest(".form");

        if (!checkRequiredFields(form)) {
            return false;
        }

        submitFormWithRecaptcha(form);
    });

    $(".one-click-form, .product-price-drop__form").on("submit", function (e) {
        e.preventDefault();
        const form = $(this);

        if (!checkRequiredFields(form)) {
            return false;
        }

        submitFormWithRecaptcha(form);
    });

    $(".form.feedback__form").on("submit", function (e) {
        const form = $(this);

        if (!checkRequiredFields(form)) {
            return false;
        }

        return true;
    });

};

function checkRequiredFields(form) {
    const requiredFields = form.find(".required:not([disabled])");
    const agreeCheck = form.find(".js-agree");

    requiredFields.each(function () {
        const elem = $(this);
        const elemVal = elem.val();

        if (elemVal.length && elem[0].checkValidity()) {
            elem.removeClass("error");
        } else {
            elem.addClass("error");
        }
    });

    if (agreeCheck.length) {
        if (agreeCheck.is(":checked")) {
            agreeCheck.removeClass("error");
        } else {
            agreeCheck.addClass("error");
        }

        if (
            form.find(".required.error").length ||
            agreeCheck.hasClass("error")
        ) {
            return false;
        }
    } else {
        if (form.find(".required.error").length) {
            return false;
        }
    }

    return true;
}

export { forms, checkRequiredFields, submitFormWithRecaptcha };
